import {IconButton, Tooltip} from "@mui/material";
import {FileDownload} from "@mui/icons-material";
import {makeAccessor} from "../../Utils/gridUtils";
import {useState} from "react";
import CircularProgress from "@mui/material/CircularProgress";
import {formatDate} from "../../Utils/dateUtils";


const CsvDownloadControl = ({page, headerGroups}) => {
    const [isLoading, setIsLoading] = useState(false);

    const convertToCsv = () => {
        const visibleData = page.map((row) => {
            let rowData = {};
            row.cells.forEach((cell) => {
                if (cell.column.column !== undefined) {
                    if (cell.column.hasOwnProperty("visible")) {
                        if (cell.column.visible) {
                            const column = makeAccessor(cell.column.column);

                            if (cell.column.hasOwnProperty("formatDate") && cell.column.formatDate) {
                                rowData[column] = formatDate(cell.value);
                            } else {
                                rowData[column] = cell.value;
                            }
                        }
                    } else {
                        const column = makeAccessor(cell.column.column);

                        if (cell.column.hasOwnProperty("formatDate") && cell.column.formatDate) {
                            rowData[column] = formatDate(cell.value);
                        } else {
                            rowData[column] = cell.value;
                        }
                    }
                }
            })

            return rowData;
        });

        let headers = [];
        headerGroups.forEach((headerGroup) => {
            headers = headerGroup.headers.filter((column) => {
                if (column.column !== undefined) {
                    if (column.hasOwnProperty("visible")) {
                        if (column.visible) {
                            return column;
                        }
                        return false;
                    } else {
                        return column;
                    }
                }
                return false;
            }).map((column) => makeAccessor(column.column))
        });

        const csvContent = visibleData.map(row =>
            headers.map(col => `"${row[col] || ''}"`).join(';')
        ).join('\n');


        return [`"${headers.join('";"')}"`, csvContent].join('\n');
    }

    const triggerDownload = (csvContent) => {
        // Create and trigger download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'data.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const handleClick = () => {
        setIsLoading(true);

        setTimeout(() => {
            const csvContent = convertToCsv();
            triggerDownload(csvContent);
            setIsLoading(false);
        }, 800);
    };

    return (
        <div style={{ display: 'inline-block' }}>
            <Tooltip title={isLoading ? "Preparing download..." : "Download CSV"}>
                <span>
                {
                    isLoading ? (

                        <IconButton disabled size="small" aria-label="Preparing Download...">
                            <CircularProgress size={20} />
                        </IconButton>
                    ) : (
                        <IconButton
                            onClick={handleClick}
                            color="#626262"
                            size="medium"
                            aria-label="Download CSV">
                            <FileDownload/>
                        </IconButton>
                    )
                }
                </span>
            </Tooltip>
        </div>


    )
}

export default CsvDownloadControl;